import React, { useEffect, useState } from 'react';
import { executionOperationsService } from '../../services/executionOperationsService';

const SUBSYSTEMS = ['calling', 'imports', 'email_campaigns', 'ai', 'webhooks', 'scheduler'];

export const OperationsPoliciesPage: React.FC = () => {
  const [slos, setSlos] = useState<unknown[]>([]);
  const [retry, setRetry] = useState<unknown[]>([]);
  const [budgets, setBudgets] = useState<unknown[]>([]);
  const [subsystem, setSubsystem] = useState('calling');

  useEffect(() => {
    void (async () => {
      const [s, r] = await Promise.all([
        executionOperationsService.getSlos(),
        executionOperationsService.getRetryPolicies(),
      ]);
      setSlos(s.data || []);
      setRetry(r.data || []);
    })();
  }, []);

  useEffect(() => {
    void (async () => {
      const b = await executionOperationsService.getResourceBudgets(subsystem);
      setBudgets(b.data || []);
    })();
  }, [subsystem]);

  return (
    <div className="space-y-4">
      <Section title="Subsystem SLOs">
        <JsonBlock data={slos} />
      </Section>
      <Section title="Retry policies">
        <JsonBlock data={retry} />
      </Section>
      <Section title="Resource budgets (informational)">
        <select
          className="mb-3 rounded border border-enterprise-200 px-3 py-2 text-sm"
          value={subsystem}
          onChange={(e) => setSubsystem(e.target.value)}
        >
          {SUBSYSTEMS.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
        <JsonBlock data={budgets} />
      </Section>
    </div>
  );
};

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="rounded-xl border border-enterprise-200 bg-white p-4 shadow-sm">
    <h2 className="mb-3 text-lg font-semibold text-enterprise-900">{title}</h2>
    {children}
  </div>
);

const JsonBlock: React.FC<{ data: unknown }> = ({ data }) => (
  <pre className="max-h-72 overflow-auto rounded bg-enterprise-50 p-3 text-xs">{JSON.stringify(data, null, 2)}</pre>
);
